module.exports = __webpack_public_path__ + "img/handshake.b5778eff.svg";